// extracted by mini-css-extract-plugin
export default {"btn":"downbtn_btn__mQOzl"};